import { ReactChild } from 'react'
import { ViewStyle } from 'react-native'
import LinearGradient from 'react-native-linear-gradient'
import { Colors } from '../../util/util'

const gradientDiection = {
  VERTICAL: 'VERTICAL',
  HORIZONTAL: 'HORIZONTAL',
}

enum GradientType {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}

interface LinearGradientContainerInterface {
  children: ReactChild
  colorArray?: (string | number)[]
  customStyle?: ViewStyle
  direction?: keyof typeof gradientDiection
  useAngle?: boolean
  angle?: number | undefined
}

export const LinearGradientContainer = ({
  children,
  colorArray = [Colors.JIO_PRIMARY, Colors.PRIMARY_GRADIENT],
  customStyle = style.linearGradient,
  direction = gradientDiection.VERTICAL as GradientType,
  useAngle = false,
  angle = 0,
}: LinearGradientContainerInterface) => {
  const isVertical = direction === gradientDiection.VERTICAL
  return (
    <LinearGradient
      start={isVertical ? { x: 0, y: 0 } : undefined}
      end={isVertical ? { x: 1, y: 0 } : undefined}
      colors={colorArray}
      useAngle={useAngle}
      angle={useAngle ? angle : undefined}
      style={customStyle}>
      {children}
    </LinearGradient>
  )
}

const style = {
  linearGradient: {
    flex: 1,
  },
}
